import config from '../config';
import { FileMetadata } from '../api/types/cms';

export const buildImageUrl = (
    file: FileMetadata | null,
    width: number | null = null,
    height: number | null = null,
): string => {
    if (!file) return '';
    return `${config.apiHost}/asset/image/${file.file_id}/${width ? Math.round(width) : ''}x${height ? Math.round(height) : ''}`;
};

export const getReadableFileSizeString = (fileSizeInBytes: number) => {
    let i = -1;
    let byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        fileSizeInBytes /= 1024;
        i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
};
